<mbt-briefing-section key="hire" icon="message-circle" title="Hire Message" [flash]="flash()"
  helper="A chat message sent automatically to each creator the moment you hire them."
  [status]="savedMessage() ? 'set' : 'missing'" (edit)="startEditing()">
  @if (savedMessage()) {
  <div class="flex flex-col gap-3.5 rounded-lg bg-(--bg-alt) p-4">
    <div class="flex flex-wrap items-center gap-2.5">
      <span class="inline-flex items-center gap-2 text-[13px] font-bold"
        [class.text-(--success)]="isEnabled()" [class.text-(--fg-3)]="!isEnabled()">
        <span class="relative inline-block h-5 w-9 rounded-full transition-colors"
          [class.bg-(--success)]="isEnabled()" [class.bg-(--border-strong)]="!isEnabled()" aria-hidden="true">
          <span class="absolute top-0.5 size-4 rounded-full bg-white transition-[left]"
            [class.left-[18px]]="isEnabled()" [class.left-0.5]="!isEnabled()"></span>
        </span>
        {{ isEnabled() ? 'On · sends when you hire a creator' : 'Off · nothing is sent when you hire' }}
      </span>
    </div>
    <div class="flex items-end gap-2.5">
      <span class="grid size-[30px] shrink-0 place-items-center rounded-full bg-(--shout-deep-purple) font-(family-name:--font-display) text-sm font-extrabold text-white" aria-hidden="true">{{ brandInitial() }}</span>
      <div class="max-w-[560px] rounded-[16px_16px_16px_4px] border border-(--border-subtle) bg-(--mba-surface) px-3.5 py-2.5 text-sm leading-[1.5] whitespace-pre-wrap">
        @for (part of messageParts(); track $index) {
          @if (part.token) {
            <span class="rounded bg-(--app-accent-soft) px-1 font-mono text-[12px] text-(--app-accent-strong)">{{ part.text }}</span>
          } @else {{{ part.text }}}
        }
      </div>
    </div>
  </div>
  } @else {
  <div [class]="bf.empty">
    <span class="flex min-w-0 flex-1 flex-col gap-0.5">
      <b [class]="bf.emptyTitle">Hired creators won’t get a welcome message</b>
      <span [class]="bf.sub">Write one so they know what happens next. It sends the moment you hire someone.</span>
    </span>
    <button type="button" [class]="bf.btnPrimary" (click)="startEditing()"><mba-icon name="plus" size="size-4" />Set up</button>
  </div>
  }
</mbt-briefing-section>

@if (editing()) {
<mbt-briefing-drawer icon="message-circle" title="Hire Message" [mode]="savedMessage() ? 'Edit' : 'Set up'"
  helper="A chat message sent automatically to each creator the moment you hire them."
  [saving]="saving()" (closed)="cancelEditing()" (save)="save()">
  <atom-hire-message-editor [(message)]="draft" [(enabled)]="enabledDraft" />
  <div class="flex flex-col gap-2">
    <span [class]="bf.k">What {{ previewName }} sees</span>
    <div class="flex items-end gap-2.5 rounded-lg bg-(--bg-alt) p-3.5">
      <span class="grid size-[30px] shrink-0 place-items-center rounded-full bg-(--shout-deep-purple) font-(family-name:--font-display) text-sm font-extrabold text-white" aria-hidden="true">{{ brandInitial() }}</span>
      <div class="max-w-[560px] rounded-[16px_16px_16px_4px] border border-(--border-subtle) bg-(--mba-surface) px-3.5 py-2.5 text-sm leading-[1.5] whitespace-pre-wrap">
        @if (preview()) { {{ preview() }} } @else { <span class="text-(--fg-3)">Your message appears here</span> }
      </div>
    </div>
  </div>
</mbt-briefing-drawer>
}
